import React from "react";
import styled, { withTheme, css } from "styled-components";
import { Button } from "@vitalsource/vstui";
import {
  BUTTON_SPACING,
  COLLECTIONS_BUTTON_WIDTH,
  EDGE_SPACING
} from "../../bookviews/consts";
import Swimlane from "../../../../components/swimlane";
import Spinner from "../../../../components/spinner";
import { createThemedComponent, createTheme } from "@vitalsource/vstui/themes";
import { styledMedia } from "../../../../components/mediaquery/breakpoints";

const collectionsStyles = css`
  width: 270px;
  height: 110px;

  ${styledMedia.medium`
    width: 200px;
    height: 80px;
    font-size: 1.6rem;
  `} ${styledMedia.small`
    width: 150px;
    height: 80px;
    font-size: 1.6rem;
  `}

  span {
    display: block;
    font-size: 1.6rem;
    font-weight: 300;
    text-align: center;
    padding-top: ${BUTTON_SPACING}px;
  }
`;

const mainButtons = {
  marginLeft: BUTTON_SPACING,
  marginRight: BUTTON_SPACING
};

const firstButton = {
  marginLeft: EDGE_SPACING,
  marginRight: BUTTON_SPACING
};

const lastButton = {
  marginLeft: BUTTON_SPACING,
  marginRight: EDGE_SPACING
};

const CollectionsButtons = createThemedComponent(Button, props => ({
  Button_backgroundColor_white: props.theme.color.base.getShade(8),
  Button_backgroundColor_white_focus: props.theme.color.base.getShade(9),
  Button_backgroundColor_white_hover: props.theme.color.base.getShade(9),
  Button_borderRadius: "8px",
  Button_fontSize_medium: 20,
  Button_fontWeight_white: 500
}));

const DisabledCollectionsButtons = createThemedComponent(
  CollectionsButtons,
  props => ({
    Button_backgroundColor_white: props.theme.vstui.color.cloud.getShade(3),
    Button_color_themePrimary_disabled: props.theme.vstui.color.cloud.getShade(
      6
    )
  })
);

export const CollectionsButton = styled(CollectionsButtons)`
  ${collectionsStyles}
`;

export const DisabledCollectionsButton = styled(DisabledCollectionsButtons)`
  ${collectionsStyles}
`;

class CollectionsLane extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getButtonStyle = i => {
    const { collections } = this.props;
    if (i === 0) {
      return firstButton;
    } else if (i === collections.length - 1) {
      return lastButton;
    }
    return mainButtons;
  };

  collectionBookCount = (gridItems, collection) => {
    let i = 0;
    let booksInCollection = 0;
    const booksInGrid = gridItems.length || 0;
    while (i < booksInGrid) {
      if (collection.includes(gridItems[i])) {
        booksInCollection++;
      }
      i++;
    }
    return booksInCollection;
  };

  renderCollections = ({ i }) => {
    const { collections, items, theme } = this.props;
    const collection = collections[i];
    const count = this.collectionBookCount(items, collection.books);

    return (
      <li key={i} style={this.getButtonStyle(i)}>
        {count ? (
          <CollectionsButton
            role="link"
            onClick={collection.onClick}
            color="white"
            colorBehindButton="white"
          >
            {collection.title}
            <span>({count})</span>
          </CollectionsButton>
        ) : (
          <DisabledCollectionsButton
            disabled
            color={theme.vstui.color.cloud.getShade(6)}
          >
            {collection.title}
            <span>({count})</span>
          </DisabledCollectionsButton>
        )}
      </li>
    );
  };

  render() {
    const { collections, isFetching, enabled } = this.props;
    if (enabled) {
      if (isFetching) {
        return <Spinner />;
      } else if (collections.length > 0) {
        return (
          <div data-testid="CollectionsLane__Swimlane">
            <Swimlane
              renderItem={this.renderCollections}
              averageItemWidth={COLLECTIONS_BUTTON_WIDTH + BUTTON_SPACING * 2}
              itemCount={collections.length}
            />
          </div>
        );
      }
    }
    return null;
  }
}

export default withTheme(CollectionsLane);
